import { Menu as HeadlessMenu } from '@headlessui/react';
import MenuButton from './MenuButton';
import MenuItem from './MenuItem';
import MenuItems from './MenuItems';
import MenuSeparator from './MenuSeparator';

const Menu = props => <HeadlessMenu {...props} />;

Menu.Button = MenuButton;
Menu.Items = MenuItems;
Menu.Item = MenuItem;
Menu.Separator = MenuSeparator;

export default Menu;
